import React, { useState, useEffect } from 'react'
import Icon from '../Icon2/Icon'
import { Truncate } from '../Truncate/Truncate'

import './TagAsSelect.css'
import { isEnterOrSpacePressed } from 'utils/keyboardUtils'
import Tooltip from '../Tooltip/Tooltip'

interface ITagList {
  label: string | React.ReactNode
  value?: string
  tooltipContent?: string
  readonly?: boolean
  readonlyTooltip?: string
}

interface ITagAsSelect {
  tags: Array<ITagList>
  updateTag: (tagToUpdate: string[]) => void
  openModalCb: (callback: any) => any
  showCount: boolean
  showEmptyState: boolean
  placeholder?: string
  showSingleItem?: boolean
  error?: Boolean
  width?: string
  seeMoreCount?: number
  selectText?: string
  tagName?: string
  showTooltip?: boolean
  maxCount?: number
  testId?: string
  version?: "v2"
  readonly?: boolean,
  tooltipContentOnCancel?: string,
  isCancelDisabled?: boolean
}

function TagAsSelect(props: ITagAsSelect) {

  const {
    showCount = false,
    showEmptyState = false,
    showSingleItem = false,
    seeMoreCount = 3,
    width = '500px',
    showTooltip = false,
    readonly = false,
    testId = 'cs-tag-as-select'
  } = props;

  const tags = props.tags && props.tags.length ? props.tags.map((t: any) => t.label) : []
  let [controlledTags, setControlledTags] = useState([])
  const [showMore, setShowMore] = useState(false)
  const tagName = props.tagName || 'Content Type'
  const { version } = props
  useEffect(() => {
    setControlledTags(props.tags && props.tags.length ? props.tags : [])
  }, [tags.join(','), props.tags.map((el) => el.value).join(',')])

  const handleClick = (e: any, index: any) => {
    if (readonly) {
      return
    }
    e.stopPropagation()
    const node = e.target
    if (node.className === 'Select__tag__item__name') {
      props.openModalCb((data) => {
        props.updateTag(data)
      })
    }
    if (node.id === 'remove_tag' || node.parentNode.id === 'remove_tag') {
      let filteredTags = controlledTags.filter((tag, i) => i !== index)
      props.updateTag(filteredTags)
    }
  }

  let indexCount: any = showMore ? controlledTags.length : seeMoreCount

  const handleKeyDown = (e: any): any => {
    if (isEnterOrSpacePressed(e.key) && !readonly) {
      e.stopPropagation()
      e.preventDefault()
      props.openModalCb((data) => {
        props.updateTag(data)
      })
    }
  }

  const setEmptyTags = (e: any) => {
    if (!readonly) {
      e.stopPropagation()
      props.updateTag([])
    }
  }

  return (
    <>
      {controlledTags.length > 0 ? (
        <div
          tabIndex={0}
          data-test-id={testId}
          className={`${controlledTags.length > 0 ? 'Select__tag' : ''} Select__tag--border ${props.error ? 'Select__tag--error' : ''} ${props.version === "v2" ? "Select__tag--v2" : ""} ${readonly ? "Select__tag--read-only" : ""}`}
          style={{ maxWidth: width }}
          onClick={(e: any) => {
            if (!readonly) {
              e.stopPropagation()
              props.openModalCb((data) => {
                props.updateTag(data)
              })
            }
          }}
          onKeyDown={handleKeyDown}
        >
          <div className={`Select__tag__container`}>
            {!showCount ? (
              controlledTags.length > 0 &&
              controlledTags.map((tag: ITagList, index: number) => {
                const label: any = tag.label
                const tooltipContent: any = tag.tooltipContent
                const isReadOnlyItem = tag?.readonly && props?.version === 'v2'
                const tooltipContentOnLock = isReadOnlyItem && tag?.readonlyTooltip && props?.version === 'v2' ? tag?.readonlyTooltip : null
                return (
                  index < indexCount && (
                    <div key={index} className={`Select__tag__items ${isReadOnlyItem ? 'Select__tag__items--disabled' : null}`} onClick={(e) => handleClick(e, index)}>
                      <div className="Select__tag__item">
                        {showTooltip ? (
                          tooltipContent ?
                            <div className={`Select__tag__item__name`}>
                              <Truncate tooltip={{ position: 'top', content: tooltipContent, disabled: false }} maxChar={props.maxCount}>{label}</Truncate>
                            </div>
                            : <div className={`Select__tag__item__name`}>
                              <Truncate maxChar={props.maxCount}>{label}</Truncate>
                            </div>
                        ) : (
                          <div className={`Select__tag__item__name`}>{label}</div>
                        )}
                        {!readonly && (
                          isReadOnlyItem ? (tooltipContentOnLock ? (<Tooltip content={tooltipContentOnLock} position={'top'}>
                            <a
                              className={`Select__tag__item__lock ${props.version === 'v2' ? 'mr-8' : ''}`}
                              id="locked_tag">
                              <Icon icon="Lock" version="v2" size="tiny" id="locked_tag" testId="cs-tag-as-select-locked-tag" />
                            </a>
                          </Tooltip>) : (<a
                            className={`Select__tag__item__lock ${props.version === 'v2' ? 'mr-8' : ''}`}
                            id="locked_tag">
                            <Icon icon="Lock" version="v2" size="tiny" id="locked_tag" testId="cs-tag-as-select-locked-tag" />
                          </a>)) : <a
                            // className="Select__tag__item__close" 
                            className={`Select__tag__item__close ${props.version === 'v2' ? 'mr-8' : ''}`}
                            id="remove_tag">
                            <Icon icon="Cancel" version="v2" size="tiny" id="remove_tag" testId="cs-tag-as-select-remove-tag" />
                          </a>
                        )
                        }
                      </div>
                    </div>
                  )
                )
              })
            ) : controlledTags.length > 0 ? (
              showSingleItem ? (
                <div className={`Select__tag__items ${controlledTags[0]?.readonly && version === 'v2' ? 'Select__tag__items--disabled' : null}`} onClick={(e) => handleClick(e, 0)}>
                  <div className="Select__tag__item">
                    {showTooltip ? (
                      <div className="Select__tag__item__name">
                        <Truncate maxChar={props.maxCount}>
                          {controlledTags && controlledTags[0] && controlledTags[0].label}
                        </Truncate>
                      </div>
                    ) : (
                      <div className="Select__tag__item__name">
                        {controlledTags && controlledTags[0] && controlledTags[0].label}
                      </div>
                    )}
                    {!readonly && (
                      controlledTags[0]?.readonly && version === 'v2' ? <a
                        className={`Select__tag__item__lock ${props.version === 'v2' ? 'mr-8' : ''}`}
                        id="locked_tag">
                        <Icon icon="Lock" version="v2" size="tiny" id="locked_tag" testId="cs-tag-as-select-locked-tag" />
                      </a> :
                        <a
                          // className="Select__tag__item__close"
                          className={`Select__tag__item__close ${props.version === 'v2' ? 'mr-8' : ''}`}
                          onClick={setEmptyTags}
                          id="remove_tag">
                          <Icon icon="Cancel" version="v2" size="tiny" id="remove_tag" testId="cs-tag-as-select-remove-tag" />
                        </a>)
                    }
                  </div>
                </div>
              ) : (
                <div className={`Select__tag__items`} onClick={(e) => handleClick(e, 0)}>
                  <div className="Select__tag__item">
                    <div className="Select__tag__item__name">
                      {controlledTags.length}{' '}
                      {props.selectText
                        ? props.selectText
                        : `${controlledTags.length > 1 ? `${tagName}s` : `${tagName}`}`}
                    </div>
                    {!readonly &&
                      <a
                        // className="Select__tag__item__close"
                        className={`Select__tag__item__close ${props.version === 'v2' ? 'mr-8' : ''}`}
                        onClick={setEmptyTags}
                        id="remove_tag">
                        <Icon icon="Cancel" version="v2" size="tiny" id="remove_tag" testId="cs-tag-as-select-remove-tag" />
                      </a>
                    }
                  </div>
                </div>
              )
            ) : (
              <div className={`Select__tag__items`} onClick={(e) => handleClick(e, 0)}>
                <div className="Select__tag__item">
                  <div className="Select__tag__item__name">
                    {controlledTags && controlledTags[0] && controlledTags[0].label}
                  </div>
                  {!readonly &&
                    <a
                      className={`Select__tag__item__close ${props.version === 'v2' ? 'mr-8' : ''}`}
                      onClick={setEmptyTags}
                      id="remove_tag">
                      <Icon icon="Cancel" version="v2" size="tiny" id="remove_tag" testId="cs-tag-as-select-remove-tag" />
                    </a>
                  }
                </div>
              </div>
            )}

            {indexCount > 0 && !showCount && indexCount === controlledTags.length && showMore && (
              <div
                className={`${props.version == "v2" ? "Select__tag__items--seemore" : "Select__tag__items"}`}
                data-test-id="show-less-button"
                onClick={(e: any) => {
                  e.stopPropagation()
                  setShowMore(false)
                }}>
                <div className="Select__tag__item">
                  <div className="Select__tag__item__name mr-5">{`Show less`}</div>
                </div>
              </div>
            )}
            {!showMore && !showCount && controlledTags.length > seeMoreCount && (
              <div
                className={`${props.version == "v2" ? "Select__tag__items--seemore" : "Select__tag__items"}`}
                data-test-id="show-more-button"
                onClick={(e: any) => {
                  e.stopPropagation()
                  setShowMore(true)
                }}>
                <div className="Select__tag__item">
                  <div className="Select__tag__item__name">{`+${controlledTags.length - seeMoreCount
                    } More`}</div>
                </div>
              </div>
            )}
          </div>
          <div className={`Select__tag__action`}>
            {controlledTags.length > 0 && !showCount && (
              <>
                {!readonly &&
                  <a className="Select__tag__action__items">
                    {props?.isCancelDisabled && version === 'v2' ? <Tooltip
                      content={props?.tooltipContentOnCancel || ''} position={'top'}
                    >
                      <Icon
                        className="Cancel__icon--disabled"
                        testId="cs-tag-as-select-remove-all"
                        icon="Cancel"
                        size="medium"
                        version="v2"
                      />
                    </Tooltip> : <Icon
                      testId="cs-tag-as-select-remove-all"
                      icon="Cancel"
                      size="medium"
                      version="v2"
                      onClick={(e: any) => {
                        setEmptyTags(e)
                        setShowMore(false)
                      }}
                    />
                    }
                  </a>
                }
                <a className="Select__tag__action__items">
                  <Icon icon={`${readonly ? "Lock" : "CaretDown"}`} version="v2" size="medium" />
                </a>
              </>
            )}
          </div>
        </div>
      ) : (
        showEmptyState && (
          <div
            tabIndex={0}
            style={{ maxWidth: width }}
            data-test-id={testId}
            className={`Select__tag__placeholder flex-v-center flex-justify ${props.error ? 'Select__tag--error' : ''} ${props.version === "v2" ? "Select__tag--v2" : ""} ${readonly ? "Select__tag--read-only" : ""}`}
            onClick={(e: any) => {
              if (!readonly) {
                e.stopPropagation()
                props.openModalCb((data) => {
                  props.updateTag(data)
                })
              }
            }}
            onKeyDown={handleKeyDown}
          >
            <div>{props.placeholder || 'Select Title'}</div>
            <a className="Select__tag__action__items">
              {<Icon icon={!readonly ? "ArrowSquareOut" : "Lock"} version="v2" size="medium" />}
            </a>
          </div>
        )
      )}
    </>
  )
}

export default TagAsSelect